import UserPicture from '../UserPicture';

import * as style from './style.module.css';

const UserGroup = ({ users = [], max = Infinity, nbUsers = 0, className = "", size = '', noMargin = false }) => {
  const toShow = Math.min(users.length, max);
  const excess = nbUsers - toShow;

  return (
    <div className={`${style.userGroup} ${noMargin ? style.noMargin : ''} ${className}`} style={size ? { '--avatar-size': size } : {}}>
      {users.slice(0, toShow).map((user) => (
        <UserPicture key={user.id} {...user} className={style.avatar} animatedPicture={null} theme="NONE" />
      ))}
      {excess > 0 && <strong className={style.excess}>+{excess}</strong>}
    </div>
  );
};

export default UserGroup;
